import { errorKind } from "@bundle/core";

/** Retry transient failures (network / 5xx); never retry auth or validation errors. */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  const kind = errorKind(error);
  return (kind === "network" || kind === "server") && failureCount < 4;
}

/** Sends keep retrying through a server outage (~4 min) before showing "Not sent · Retry". */
export function shouldRetrySend(failureCount: number, error: unknown): boolean {
  const kind = errorKind(error);
  return (kind === "network" || kind === "server") && failureCount < 10;
}

export const retryDelay = (attempt: number) => Math.min(30_000, 1000 * 2 ** attempt);

